<div class="border-top flex flex-wrap items-center justify-between gap-4 pt-6">
  <app-records-counter [numberOfRecords]="totalItems"></app-records-counter>
  <ngb-pagination
    class="-mb-4 mr-4"
    [disabled]="disabled"
    [collectionSize]="totalItems"
    [(page)]="currentPage"
    [maxSize]="5"
    [pageSize]="pageSize"
    [rotate]="true"
    [boundaryLinks]="false"
    (pageChange)="emitPageChange($event)"
  ></ngb-pagination>
  <app-page-size-menu [disabled]="disabled" (valueChanges)="emitChangeListSize($event)"></app-page-size-menu>
</div>
